import React, { useEffect } from 'react'
import AOS from "aos";
import "aos/dist/aos.css";

const OurSolution = () => {
  useEffect(() => {
    AOS.init({
      once: false,
      duration: 800,
      easing: 'ease-out'
    });
  }, []);

  return (
   <section className="lg:py-28 lg:px-12 px-4 py-12 bg-bgDefault text-white overflow-x-hidden">
      <div className="container mx-auto w-full max-w-full max-w-screen-xl overflow-hidden">
        {/* Header */}


        {/* Content Container */}
        <div className="lg:px-[168px]">
          {/* Description */}
          <h2
            className="text-3xl lg:text-4xl font-bold tracking-tight mb-6 lg:mb-8"
            data-aos="fade-down"
          >
            What We Did & How We Did It
          </h2>

          {/* <h3 className="text-2xl lg:text-3xl font-semibold text-[#00E599] mb-4">What We Did & How We Did It</h3> */}

          <p
            className="text-[#9E9E9E] text-base lg:text-lg leading-relaxed mb-6"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            We architected a mission-critical Traffic Data Management System (TDMS) using Spring Boot microservices
            for robust backend processing, Angular for interactive dashboards, and PostgreSQL for reliable data
            persistence. The platform integrates ArcGIS API for advanced geospatial visualization, enabling the
            Ministry to visualize traffic patterns, road conditions, and infrastructure on interactive maps. Deployed
            on AWS Cloud with Docker containerization, the solution processes traffic data from 500,000+ vehicles daily,
            integrates IoT sensors, CCTV camera feeds, GPS tracking systems, and manual survey data into unified analytics.
            Spring Security with role-based access control protects sensitive government data, while AWS auto-scaling
            ensures reliability during peak traffic events including FIFA World Cup 2022.
          </p>

          <h4
            className="text-xl font-semibold text-white mb-3"
            data-aos="fade-right"
            data-aos-delay="200"
          >
            Core Features Delivered:
          </h4>
          <ul className="text-[#9E9E9E] text-base lg:text-lg leading-relaxed mb-6 list-disc pl-5 space-y-2">
            <li data-aos="zoom-in" data-aos-delay="250"><strong>TDMS Platform Development:</strong> Full-stack Traffic Data Management System built with Spring Boot REST APIs, Angular dashboards, and PostgreSQL database for nationwide traffic monitoring</li>
            <li data-aos="zoom-in" data-aos-delay="300"><strong>Multi-Source Data Integration:</strong> ETL pipelines aggregating data from 500,000+ vehicles, IoT traffic sensors, CCTV cameras, GPS tracking, and manual surveys into unified platform</li>
            <li data-aos="zoom-in" data-aos-delay="350"><strong>ArcGIS Geospatial Visualization:</strong> Interactive map-based dashboards displaying real-time traffic density, road conditions, accident hotspots, and infrastructure planning overlays</li>
            <li data-aos="zoom-in" data-aos-delay="400"><strong>FIFA World Cup 2022 Support:</strong> High-availability infrastructure managing peak traffic during global sporting event with millions of visitors and worldwide media coverage</li>
            <li data-aos="zoom-in" data-aos-delay="450"><strong>Real-Time Traffic Analytics:</strong> Live monitoring dashboards tracking vehicle flow, congestion patterns, average speeds, and traffic anomalies across entire road network</li>
            <li data-aos="zoom-in" data-aos-delay="500"><strong>Secure Access Control:</strong> Role-based authentication using Spring Security reducing data breach risks by 40%, protecting sensitive transportation infrastructure data</li>
            <li data-aos="zoom-in" data-aos-delay="550"><strong>Master Plan Reporting:</strong> Comprehensive analytics reports supporting Ministry's long-term infrastructure planning, road expansion projects, and budget allocation decisions</li>
            <li data-aos="zoom-in" data-aos-delay="600"><strong>AWS Cloud Deployment:</strong> Docker containerization on AWS EC2, RDS PostgreSQL, S3 for data lake storage, and CloudWatch monitoring for 99.9% uptime</li>
            <li data-aos="zoom-in" data-aos-delay="650"><strong>Data Quality Validation:</strong> Automated validation rules ensuring accuracy of traffic data used for critical government decision-making and public safety</li>
            <li data-aos="zoom-in" data-aos-delay="700"><strong>Scalable Architecture:</strong> Microservices design handling massive concurrent data streams without performance degradation during peak traffic periods</li>
          </ul>

          <h2
            className="text-3xl lg:text-4xl font-bold tracking-tight mb-6 lg:mb-8"
            data-aos="fade-down"
            data-aos-delay="750"
          >
            Results Achieved
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
            <div
              className="bg-[#242424] p-6 rounded-lg border border-[#00E599]/20"
              data-aos="flip-left"
              data-aos-delay="800"
            >
              <h5 className="text-3xl font-bold text-[#00E599] mb-2">FIFA 2022</h5>
              <p className="text-[#9E9E9E]">Successfully supported traffic management during World Cup without major incidents</p>
            </div>
            <div
              className="bg-[#242424] p-6 rounded-lg border border-[#00E599]/20"
              data-aos="flip-left"
              data-aos-delay="850"
            >
              <h5 className="text-3xl font-bold text-[#00E599] mb-2">500K+</h5>
              <p className="text-[#9E9E9E]">Vehicles monitored daily with real-time traffic data processing</p>
            </div>
            <div
              className="bg-[#242424] p-6 rounded-lg border border-[#00E599]/20"
              data-aos="flip-left"
              data-aos-delay="900"
            >
              <h5 className="text-3xl font-bold text-[#00E599] mb-2">40%</h5>
              <p className="text-[#9E9E9E]">Reduction in data breach risks through secure access controls</p>
            </div>
            <div
              className="bg-[#242424] p-6 rounded-lg border border-[#00E599]/20"
              data-aos="flip-left"
              data-aos-delay="950"
            >
              <h5 className="text-3xl font-bold text-[#00E599] mb-2">100%</h5>
              <p className="text-[#9E9E9E]">GIS-based visualization coverage for Master Plan strategic decisions</p>
            </div>
            <div
              className="bg-[#242424] p-6 rounded-lg border border-[#00E599]/20"
              data-aos="flip-left"
              data-aos-delay="1000"
            >
              <h5 className="text-3xl font-bold text-[#00E599] mb-2">99.9%</h5>
              <p className="text-[#9E9E9E]">Platform uptime during critical FIFA World Cup period</p>
            </div>
            <div
              className="bg-[#242424] p-6 rounded-lg border border-[#00E599]/20"
              data-aos="flip-left"
              data-aos-delay="1050"
            >
              <h5 className="text-3xl font-bold text-[#00E599] mb-2">24/7</h5>
              <p className="text-[#9E9E9E]">Real-time traffic monitoring and alerting capabilities</p>
            </div>
          </div>

          <p
            className="text-[#9E9E9E] text-base lg:text-lg leading-relaxed"
            data-aos="fade-up"
            data-aos-delay="1100"
          >
            The Traffic Data Management System transformed how the Ministry of Road Transportation monitors and manages
            nationwide traffic infrastructure. By successfully supporting FIFA World Cup 2022 under intense global
            scrutiny, the platform demonstrated its mission-critical reliability and scalability. GIS-based visualizations
            empowered strategic Master Plan decisions for road expansion and infrastructure investments, while real-time
            analytics enabled proactive traffic management. The solution established new standards for government-scale
            transportation systems, positioning the Ministry as a regional leader in smart traffic management innovation
            and data-driven urban planning.
          </p>
        </div>
      </div>
    </section>
  )
}

export default OurSolution
